import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiX, FiCopy, FiCheck, FiShare2, FiLink, FiTwitter, FiFacebook } = FiIcons;

const ShareModal = ({ isOpen, onClose, shareUrl }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(shareUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const shareLinks = [
    { 
      name: 'Twitter', 
      icon: FiTwitter, 
      url: `https://twitter.com/intent/tweet?text=Check out this radio station!&url=${encodeURIComponent(shareUrl)}`,
      color: 'bg-[#1DA1F2]'
    },
    { 
      name: 'Facebook', 
      icon: FiFacebook, 
      url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`,
      color: 'bg-[#1877F2]'
    }
  ];

  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/80 backdrop-blur-md">
          <motion.div 
            initial={{ opacity: 0, scale: 0.9, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 20 }}
            className="bg-white rounded-[3rem] shadow-2xl w-full max-w-md overflow-hidden"
          >
            <div className="p-8 border-b border-gray-50 flex justify-between items-center">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-2xl bg-[#00AEEF]/10 text-[#00AEEF] flex items-center justify-center">
                  <SafeIcon icon={FiShare2} className="text-xl" />
                </div>
                <div>
                  <h3 className="font-black text-gray-900 uppercase tracking-tight">Share Player</h3>
                  <p className="text-[10px] text-gray-400 font-bold uppercase tracking-widest">Standalone link</p>
                </div>
              </div>
              <button onClick={onClose} className="p-3 hover:bg-gray-100 rounded-2xl transition-colors text-gray-400">
                <SafeIcon icon={FiX} />
              </button>
            </div>

            <div className="p-8 space-y-8">
              {/* Direct Link Section */}
              <div className="space-y-3">
                <p className="text-[10px] text-gray-400 font-black uppercase tracking-widest">Direct Player Link</p>
                <div className="flex gap-2">
                  <div className="flex-1 bg-gray-50 border border-gray-100 rounded-2xl px-5 py-4 text-xs font-mono text-gray-500 truncate">
                    {shareUrl}
                  </div>
                  <button 
                    onClick={handleCopy}
                    className="px-6 bg-gray-900 text-white rounded-2xl font-black text-[10px] uppercase tracking-widest hover:bg-[#00AEEF] transition-all flex items-center gap-2 shrink-0"
                  >
                    <SafeIcon icon={copied ? FiCheck : FiCopy} />
                    {copied ? 'Copied' : 'Copy'}
                  </button>
                </div>
              </div>

              {/* Social Grid */}
              <div className="grid grid-cols-2 gap-4">
                {shareLinks.map((link) => (
                  <a 
                    key={link.name}
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center gap-3 p-5 rounded-[1.5rem] bg-gray-50 border border-gray-100 hover:border-[#00AEEF]/30 hover:bg-white transition-all group"
                  >
                    <div className={`w-8 h-8 rounded-lg ${link.color} text-white flex items-center justify-center shadow-lg shadow-blue-500/10`}>
                      <SafeIcon icon={link.icon} />
                    </div>
                    <span className="text-[10px] font-black text-gray-900 uppercase tracking-widest">{link.name}</span>
                  </a>
                ))}
              </div>
              
              <div className="bg-[#F0F9FF] p-4 rounded-2xl border border-[#BAE6FD] flex items-center gap-3">
                <SafeIcon icon={FiLink} className="text-[#00AEEF]" />
                <p className="text-[9px] font-bold text-[#00AEEF] uppercase leading-relaxed">
                  This link bypasses the builder and shows only the player interface.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default ShareModal;